import { Box, Text } from "@chakra-ui/react";
import { formatDate, Link } from "@components/ui-kit";
import { useInvoiceDetailStore } from "@src/components/modules/invoices/Detail/store";
import { TIME_BILLING_URL_PARAMS } from "@src/components/modules/projects/time-billing/constants";
import { getProjectTitle } from "@src/components/widgets/ModuleTitle/ProjectTitle";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

export const TimeBillingList = observer(function TimeBillingList() {
  const { workspaceStore } = useStore();
  const store = useInvoiceDetailStore();
  const timeBilling = store.invoice?.projectTimeBilling;

  if (!timeBilling) return null;

  return (
    <Box>
      <Link
        href={{
          pathname: "/projects/time-billing",
          query: {
            id: timeBilling.project.id,
            [TIME_BILLING_URL_PARAMS.EXPAND]: timeBilling.id,
          },
        }}
      >
        <Text>
          {getProjectTitle(
            timeBilling.project,
            workspaceStore.settings?.enableAdditionalBrandNumericCode,
          )}
          ,&nbsp;({formatDate(new Date(timeBilling.date_from))}&nbsp;-&nbsp;
          {formatDate(new Date(timeBilling.date_to))})
        </Text>
      </Link>
    </Box>
  );
});
